<template minapp='mpx' xlang='wxml'>
  <view class="container-header">
    <view class="inner-box caldendar-date-style">
      <!-- scroll-left="{{scrollLeft}}" -->
      <scroll-view
      scroll-x
      enable-flex
      enhanced="{{true}}"
      bounces
      scroll-options="{{{ bounce: {top: true,bottom: true,left: true,right: true} }}}"
      scroll-into-view="{{scrollLeft}}"
      scroll-with-animation
      id="scrollview"
      >
        <view
        class="calendar"
        wx:style="{{{width: days.length > 5 ? (days.length + 1) * 63 + 'px' : 'calc(100% + 1px)'}}}"
        >
          <view
          wx:for="{{days}}"
          wx:key="{{index}}"
          id="{{'day-item-' + index}}"
          wx:class="{{{ isActived: index === chosed, noCheck:!item.canCheck}}}"
          class="calendar-item"
          bindtap="handleClickDay(index,item)"
          >
            <text class="week" wx:class="{{{ isActivedText: index === chosed }}}">{{item.weekText}}</text>
            <text class="date" wx:class="{{{ isActivedText: index === chosed }}}">{{item.dateText}}</text>
          </view>
        </view>
      </scroll-view>
      <view class="more" bindtap="handleMoreClick">
        <view class="more-text">
          <image class="more-icon" src="https://dpubstatic.udache.com/static/dpubimg/PeQ8bmXWAHVco7e9oNYuR.png"></image>
          更多
        </view>
      </view>
    </view>
  </view>

  <es-popup
  show="{{ show }}"
  closeable="{{closeable}}"
  bind:close="onClose"
  position="bottom"
  >
    <es-calendar 
    value="{{innerVal}}" 
    disabled="{{disabled}}"
    type="{{checkType}}"
    title="{{title}}"
    formatter="{{formatter}}"
    color="{{color}}"
    show-confirm="{{showConfirm}}"
    start-text="{{startText}}"
    end-text="{{endText}}"
    confirm-text="{{confirmText}}"
    first-day="{{firstDay}}"
    max-range="{{maxRange}}" 
    maxDate="{{innerMaxDate}}"
    minDate="{{innerMinDate}}"
    format="{{format}}"
    allow-same-day="{{allowSameDay}}"
    bind:confirm="onConfirm"
    bind:input="onInput"
    >
    </es-calendar>
  </es-popup>
</template>
<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { getFullDate } from '@didi/es-mpx-shared'
  import { formatDate } from '@didi/es-mpx-shared'

  createComponent({
    classes: ['caldendar-date-style'],
    props:{
      // 默认值 timestamp | timestamp[],传到e组件里面的value
      value: {
        type: Array,
        optionalTypes: [Number, String]
      },
      // 选定时间的前后可选时间
      checkRange:{
        type: Number,
        value: 7
      },
      // 设置日期格式
      dateType:{
        type: String,
        value: 'MM-dd'
      },
      // 最大时间
      maxHeaderDate:null,
      // 最小时间
      minHeaderDate:null,
      // 是否联动
      linking: {
        type: Boolean,
        value: false
      },
      // 是否每次点击等多都要更新
      isUpdateEveryTime: {
        type: Boolean,
        value: false
      },
      // 设置是否可选
      disabled: Boolean,
      // 日历类型 range|single|multiple
      checkType: String,
      // 是否展示弹层的 [x]
      closeable: {
        type: Boolean,
        value: false
      },
      // 标题
      title: String,
      // 自定义时间格式化
      formatter: null,
      // 选中底色
      color: String,
      // 是否显示底部确定按钮
      showConfirm:Boolean,
      // 起始选中文案
      startText: String,
      // 终止选中文案
      endText: String,
      // 底部按钮文案
      confirmText: String,
      // 起始周
      firstDay: Number,
      // 可选择最小时间
      minDate: Number,
      // 可选择最大时间
      maxDate: Number,

      format: null,
      // 多选最多可以选几个
      maxRange: Number,
      allowSameDay: Boolean,
      isRequest: {
        type: Boolean,
        value: false
      }
    },
    data: {
      days: [],
      chosed: 0,
      pre_chosed: 0,
      show: false,
      showDialog: false,
      innerVal: [],
      innerMaxHeaderDate:undefined,
      innerMinHeaderDate:undefined,
      // scrollLeft:0,
      transformVal:0,
      isOnedarger:false
    },

    computed: {
      innerMaxDate(){
        return this.maxDate?this.maxDate:new Date().setHours(0, 0, 0, 0)+ 1000 * 60 * 60 * 24 * 365
      },
      innerMinDate(){
        return this.minDate?this.minDate:new Date().setHours(0, 0, 0, 0) 
      },
      scrollLeft(){
        let left = 0
        if(this.chosed<2){
          left = 0
        }else{
          left = this.chosed - 2
        }
        return `day-item-${left}`
      }

    },

    created(){
      this.innerVal = Array.isArray(this.value) ? this.value.slice() : [this.value]
      this.innerMaxHeaderDate = this.maxHeaderDate
      this.innerMinHeaderDate = this.minHeaderDate
      this.initDays() 
    },
    mounted() {
    },

    watch: {
      value(val) {
        this.$nextTick(() => {
          const arr = Array.isArray(val) ? val.slice() : [val]
          this.innerVal = arr.sort()
          this.initDays()
        })
      },
      maxHeaderDate(val){
        this.innerMaxHeaderDate = val?new Date(val).setHours(0, 0, 0, 0):null
        this.initDays()
      },
      minHeaderDate(val){
        this.innerMinHeaderDate = val?new Date(val).setHours(0, 0, 0, 0):null
        this.initDays()
      },
    },

    methods: {
      changeType(){
        this.isActive = !this.isActive
      },
      onClose() {
        this.show = false
      },

      getDays(timeStamp,canCheck){
        const  weeks = ['日', '一', '二', '三', '四', '五', '六']
        const { week,day } = getFullDate(timeStamp)
        const item = {
          canCheck,
          timeStamp,
          weekText: timeStamp === new Date().setHours(0, 0, 0, 0)? '今天':'周' + weeks[week],
          dateText: formatDate(timeStamp,this.dateType)
        }
        return item
      },

      range(min, max) {
        let times = []
        let start = new Date(min)
        let end = new Date(max)
        end.setHours(0, 0, 0, 0)
        start.setHours(0, 0, 0, 0)
        let initIndex = 0
        while (start.getTime() <= end.getTime()) {
          if(new Date(this.innerVal[0]).setHours(0, 0, 0, 0) === start.setHours(0, 0, 0, 0)){
            this.chosed = initIndex
            this.pre_chosed = initIndex
          }
          initIndex++
          times.push(this.getDays(start.getTime(),true))
          start.setDate(start.getDate() + 1)
        }
        
        while(initIndex < 5){
          initIndex++
          times.push(this.getDays(start.getTime(),false))
          start.setDate(start.getDate() + 1)
        }
        return times
      },

      initDays() {
        // 对传入的value处理

        let today = new Date().setHours(0, 0, 0, 0)
        // 选中日期起止
        let endTime = this.innerMaxHeaderDate
        let startTime = this.innerMinHeaderDate
        // 如果minHeaderDate和maxHeaderDate都传了则优先
        if(!endTime||!startTime){
          startTime = startTime||this.innerVal[0] - 1000 * 60 * 60 * 24 * this.checkRange
          endTime = endTime||this.innerVal[1]||this.innerVal[0] + 1000 * 60 * 60 * 24 * this.checkRange
        }

        // 不取今天之前
        if(startTime < today){
          startTime = today
        }
        this.days = this.range(startTime, endTime)
      },

      // 选中的值与range的值比较，取InnerVal
      getInnerVal(){
        const checkdeTime = this.days[this.chosed].timeStamp
        let [setMin, setMax] = this.value
        if(!!setMax&&checkdeTime>setMax){
          setMax = checkdeTime
        }
        return [checkdeTime, setMax]
      },

      handleClickDay(index,item) {
        if(this.isRequest) return 
        if(item.canCheck){
          this.pre_chosed = this.chosed
          this.chosed = index
        }
        this.$nextTick(() => {
          this.$trigger('handleClickDay', {data:this.getInnerVal(),canCheck:item.canCheck})
        })
      },

      // 返回上一个选择
      returnToPre() {
        setTimeout(() => {
          this.chosed = this.pre_chosed
        }, 500);
        this.$nextTick(() => {
          this.$trigger('returnToPre', this.getInnerVal())
        })
      },

      handleMoreClick() {
        if(this.isRequest) return 
        this.show = true
        let [ min, max ] = this.getInnerVal()
        if( this.isUpdateEveryTime ){
          min = +min + Math.floor(Math.random() * (100 - 1)) + 1
        }
        this.innerVal = [ min, max ]
      },
      // 底部点击事件
      onConfirm(data) {
        this.show = false
        this.$trigger('confirm', data.detail)
        this.$nextTick(() => {
          if(this.linking){
            const [min, max] = data.detail
            // 如果是限制最大是返程时间，那么返回的时候更新最大时间
            this.innerMaxHeaderDate = max&&this.maxHeaderDate?max:this.maxHeaderDate
            this.innerVal = [min,max]
            this.initDays()
          }
        })
      },
      // 每次点击触发value
      onInput(data) {
        this.$nextTick(() => {
          this.$trigger('input', data.detail)
        })
      },
    },
  })
</script>

<style lang="stylus" scoped>
  .container-header
    display flex
    justify-content center
    color #10294D
    font-size 12px
    font-weight 500
    position relative
    margin-bottom 8px
    // background #FFFFFF
  .inner-box
    height 44px
    width 100%
    overflow hidden
    display flex
    margin-top 7.93px
    margin-bottom 6.44px
  .week
    font-size 11px
    font-family Ping Fang SC
    font-weight 400
    color #666666
  .calendar
    display flex
    height 100%
    flex-wrap nowrap
    flex-direction row
  .calendar-item
    display flex
    width 55px
    height 42px
    flex-shrink 0
    flex-direction column
    justify-content center
    text-align center
    box-sizing border-box
    margin-right 8px
    &:first-child
      margin-left 8px
  .date 
    font-family Barlow Semi Condensed
    font-size 16px
    font-weight 400
    color #000
  .isActived
    border-radius 7px
    background #FF6400
  .isActivedText
    color #ffffff 
  .noCheck
    color #BBBBBB
  .more
    position absolute
    right 0
    top 5px
    background #fff
    width 55px
    height 50px
    display flex
    justify-content center
    align-items center
    &::before
      // display inline-block
      content ''
      position absolute
      top 0
      left -20px
      background url('https://dpubstatic.udache.com/static/dpubimg/xbwB5ItEJBECZ7VlQYvU7.png')
      height 50px
      width 20px
  .more-text
    display flex
    flex-direction column
    justify-content center
    align-items center
    text-align center
    color #666666
    font-weight 400
    font-size 11px
    .more-icon
      width 17.5px
      height 15.5px
      margin-bottom 4px
</style>

<script name='json'>
  module.exports = {
    navigationBarTitleText: "日期选择",
    component: true,
    usingComponents: {
      'es-popup': '@didi/es-mpx-ui/lib/popup',
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-calendar': '@/components/calendar',
    }
  }
</script>
